module.exports = __webpack_public_path__ + "img/d201404_2.2b3c9342.jpg";